import { createAction } from "@ngrx/store";

export class TawAppStateAction {
  private static key : string = 'TawAppStateAction'
  public static update = createAction(`${TawAppStateAction.key} update`);
}
